module.exports = __webpack_public_path__ + "img/es-rdf-en.fea9bd24.svg";